import { render, staticRenderFns } from "./BookingsHandle.vue?vue&type=template&id=2b6b293a&"
import script from "./BookingsHandle.vue?vue&type=script&lang=js&"
export * from "./BookingsHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports